import { Toggle } from '@warp-ds/react/components/toggle';
import type { FilterProps } from '@/scenes/resultPage/components/filters/types';

const valueToBoolean = (value: unknown) => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value !== 'false';
    }
    return Boolean(value);
};

export const TransactionalFilter = ({ filters, onFilterChanged }: FilterProps) => (
    <Toggle
        type="checkbox"
        label="Enkel bestilling"
        checked={valueToBoolean(filters.is_transactional)}
        onChange={(checked: boolean) => onFilterChanged({ is_transactional: checked })}
    />
);
